import Swiper from 'swiper'
import { Pagination, Navigation, Mousewheel } from 'swiper/modules'

function initializeSectionSliderBlock(root) {
    if (!root || root.dataset.sectionSliderInitialized === 'true') {
        return;
    }

    const swiperEl = root.querySelector('.section-slider__swiper');

    if (!swiperEl) {
        return;
    }

    root.dataset.sectionSliderInitialized = 'true';

    const view = root.ownerDocument.defaultView;

    const state = {
        swiper: null,
        isDesktop: null,
    };

    const initSwiper = () => {
        const isDesktop = view.matchMedia('(min-width:991px)').matches;

        const paginationDesktop = {
            el: root.querySelector('.swiper-pagination--desktop'),
            clickable: true,
            renderBullet: function (index, className) {
                return `<div class="section-slider__bullet ${className}"><svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14 1L7.5 8L1 1" stroke="#FF0032" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>${this.slides[index].dataset.title}</div>`;
            },
        };
        const paginationMobile = {
            el: root.querySelector('.swiper-pagination--mobile'),
            clickable: true,
        };

        state.swiper = new Swiper(swiperEl, {
            modules: [Pagination, Navigation, Mousewheel],
            loop: true,
            speed: 600,
            slidesPerView: 1,
            allowTouchMove: true,
            initialSlide: 0,
            pagination: isDesktop ? paginationDesktop : paginationMobile,
            mousewheel: {
                forceToAxis: true,
            },
            navigation: {
                nextEl: root.querySelector('.swiper-button-next'),
                prevEl: root.querySelector('.swiper-button-prev'),
            },
        });
    };

    state.isDesktop = view.matchMedia('(min-width:991px)').matches;
    initSwiper();

    const handleResize = () => {
        const isDesktop = view.matchMedia('(min-width:991px)').matches;

        if (isDesktop === state.isDesktop) return;
        state.isDesktop = isDesktop;

        if (state.swiper !== null) {
            state.swiper.destroy(true, true);
            state.swiper = null;
            initSwiper();
        }
    };

    view.addEventListener('resize', handleResize);

    // Named handler (not anonymous) so it can actually be removed: without
    // this, deleting/replacing the block in the editor would leave the
    // listener attached to the iframe's window forever, holding root,
    // state, and the Swiper instance alive. ACF fires a generic 'remove'
    // action (used internally for repeater-row teardown, among other DOM
    // removals) with the removed element as a jQuery object; treated here
    // as best-effort cleanup since it could not be confirmed in a live
    // browser that it fires for whole block-preview removal specifically.
    if (window.acf) {
        window.acf.addAction('remove', ($el) => {
            const removedEl = $el && typeof $el.get === 'function' ? $el.get(0) : $el;

            if (!removedEl || (removedEl !== root && !(removedEl.contains && removedEl.contains(root)))) {
                return;
            }

            view.removeEventListener('resize', handleResize);

            if (state.swiper) {
                state.swiper.destroy(true, true);
                state.swiper = null;
            }
        });
    }
}

function initializeFrontend() {
    document.querySelectorAll('.section-slider').forEach(initializeSectionSliderBlock);
}

if (window.acf) {
    window.acf.addAction('render_block_preview/type=section-slider', ($block) => {
        initializeSectionSliderBlock($block.get(0));
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeFrontend);
} else {
    initializeFrontend();
}
